@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.TutorialHuds .TutorialHud {
  z-index: 20;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 8em;
  height: 4em;
  margin-top: -2em;
  margin-left: -4em;
  pointer-events: none;
  visibility: hidden;
}
.TutorialHuds .TutorialHud[isRendered] {
  visibility: visible;
}
.TutorialHuds .TutorialHud .TutorialBox {
  padding: 0.33em 0.53394em;
  text-align: center;
  pointer-events: all;
  border-radius: 0.1em;
  color: #f0ead6;
  background-color: #111111;
  color: #111111;
  background-color: #f0ead6;
}
.TutorialHuds .TutorialHud .TutorialBox .Text {
  font-size: 0.25em;
}
.TutorialHuds .TutorialHud .TutorialBox .Text [element=water] {
  color: #639bff;
}
.TutorialHuds .TutorialHud .TutorialBox .Text [element=fire] {
  color: #d54b33;
}
.TutorialHuds .TutorialHud .TutorialBox .Text [element=earth] {
  color: #62C370;
}
.TutorialHuds .TutorialHud .TutorialBox .Link {
  opacity: 0.5;
  font-size: 0.25em;
  width: 5em;
  margin: auto;
  margin-top: 0.5em;
}
.TutorialHuds .TutorialHud .TutorialBox .Link:hover {
  opacity: 1;
  color: #d54b33;
  cursor: pointer;
}
.RollingHud {
  top: 0.5em;
  left: 0em;
  right: 0em;
  z-index: 10;
  position: absolute;
  text-align: center;
  font-style: italic;
  opacity: 0;
  transition-delay: 0s;
  transition-duration: 1s;
  transition-property: opacity;
}
.RollingHud[isVisible] {
  opacity: 1;
  transition-delay: 1s;
  transition-duration: 2s;
}
.RollingHud .Text {
  font-size: 0.3em;
}
.TriangleHud {
  top: 0em;
  right: 0em;
  width: 3em;
  height: 3em;
  z-index: 10;
  position: absolute;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("@fae/source/assets/images/ember-tactics/weapon-triangle.png");
}
